import { Building2Icon, FolderIcon, ShieldIcon } from "lucide-react";
import { NavLink, Redirect, Route, Switch, useParams } from "react-router-dom";
import { CompanyDetails } from "./company";
import { IndexingSettings } from "./indexing";
import { RolesSettings } from "./roles";

const NAV_ITEMS = [
  {
    label: "Details",
    path: "details",
    icon: Building2Icon,
  },
  {
    label: "Data Room",
    path: "data-room",
    icon: FolderIcon,
  },
  {
    label: "Roles",
    path: "roles",
    icon: ShieldIcon,
  },
] as const;

export function DealSettingsPage() {
  const { dealId } = useParams<{ dealId: string }>();

  return (
    <div className="flex h-full bg-background">
      <aside className="w-56 shrink-0 border-r border-border pt-2 pb-6 px-3">
        <nav className="flex flex-col gap-0.5">
          {NAV_ITEMS.map(({ label, path, icon: Icon }) => (
            <NavLink
              key={path}
              to={`/deal/${dealId}/settings/${path}`}
              className="flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted/60 hover:text-foreground"
              activeClassName="!bg-muted !text-foreground"
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex-1 overflow-y-auto">
        <div className="px-8 py-8 lg:px-10">
          <Switch>
            <Route path="/deal/:dealId/settings" exact>
              <Redirect to={`/deal/${dealId}/settings/details`} />
            </Route>
            <Route path="/deal/:dealId/settings/details">
              <CompanyDetails />
            </Route>
            <Route path="/deal/:dealId/settings/data-room">
              <IndexingSettings />
            </Route>
            <Route path="/deal/:dealId/settings/roles">
              <RolesSettings />
            </Route>
            <Route path="/deal/:dealId/settings/permissions">
              <Redirect to={`/deal/${dealId}/settings/roles`} />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
}
